import React, { Component } from 'react';
import './Board.css';
import { swappableIndices, positionCircle } from '../iconSetup.js';
 
function Icon(props) {
    const alt = 'icon' + toString(props.idx);
    return (
        <input type='image' className='icon'
          src={props.url}
          alt={alt}
          id = {props.id}
          onClick={props.onClick}
          onMouseOver={props.onMouseOver}
          onMouseOut={props.onMouseOut}
        />
    );
}

export function resetIconStyle(numIcons) {
  for (var i=0; i<numIcons; i++) {
    document.getElementById(i).style.opacity = '1';
    document.getElementById(i).style.backgroundColor = 'unset';
  }
}

class Board extends Component {
    constructor(props) {
      super(props);
      this.state = {
        selected: null, //index of selected icon; null if none 
        swappable: Array(this.props.numIcons),  //indices of swappable icons
        coordinates: Array(this.props.numIcons),  // coordinates of icon positions
      };
    }

    focusOut = () => {
      this.setState({
        selected: null,
      });
      resetIconStyle(this.props.numIcons);
    }

    onMouseOver(i) {
      // if nothing selected: highlight icons
      if (this.state.selected === null) {
        this.highlightIcons(i);
      }
    }

    onMouseOut() {
      // if nothing selected: reset style
      if (this.state.selected == null) {
        resetIconStyle(this.props.numIcons);
      } 
    }

    highlightIcons(i) {
      let swappable = this.state.swappable;
      document.getElementById(i).style.backgroundColor = 'rgba(95, 131, 166, 0.3)';

      for (let idx=0; idx<swappable[i].length; idx++) {
        document.getElementById(swappable[i][idx]).style.backgroundColor = 'rgba(69, 61, 52, 0.3)';
      }
    }

    moveIcons(first,second) {
      let coords = this.state.coordinates;
      let icon1 = document.getElementById(first);
      let icon2 = document.getElementById(second);
  
      // show the two icons swapping
      icon1.style.cssText = `left: ${coords[second][0]}px; top: ${coords[second][1]}px`;
      icon2.style.cssText = `left: ${coords[first][0]}px; top: ${coords[first][1]}px`;
      icon1.style.transitionDuration = '0.6s';
      icon2.style.transitionDuration = '0.6s';
      
      icon2.ontransitionend = () => {
        // move the icons back, then swap source image in this.swap
        icon1.style.transitionDuration = 'unset';
        icon2.style.transitionDuration = 'unset';
        icon1.style.cssText = `left:${coords[first][0]}px; top:${coords[first][1]}px;`;
        icon2.style.cssText = `left:${coords[second][0]}px; top:${coords[second][1]}px;`;
        this.swap(first,second);
        icon2.ontransitionend = null; // ontransitionend fires multiple times; execute only once
      };
    }

    swap(x,y) {
      let imgSrc = this.props.iconOrder;
      let temp = imgSrc[x];
      imgSrc[x] = imgSrc[y];
      imgSrc[y] = temp;
      this.setState({
        imgSrc: imgSrc,
        selected: null,
      });
      this.props.setOrder(imgSrc);
    }

    handleClick(event, i) {
      event.stopPropagation();  // override focusOut
      let selected = this.state.selected;
      let swappable = this.state.swappable;

      if (selected !== null && swappable[selected].includes(i)) {
        // selected icons can be swapped
        this.moveIcons(i, selected);
        resetIconStyle(this.props.numIcons);
      } else {  // nothing has been selected yet, or selecting a different icon
        this.setState({
          selected: i,
        });

        // style icons appropriately
        resetIconStyle(this.props.numIcons);
        for (let idx=0; idx<this.props.numIcons; idx++) {
          if (idx !== i && idx !== swappable[i][0] && idx !== swappable[i][1]) {
            // fade out the unswappable icons
            document.getElementById(idx).style.opacity = '0.5';
          }
        }
        this.highlightIcons(i);
      } 
    }

    render() {
      // console.log(this.state.selected);
      // console.log(this.state.swappable[this.state.selected]);
    
      return (
          <div onClick={this.focusOut}>
            <div id='disc'>
              <div id='hole'></div>
              {this.props.iconOrder.map((image, i) => 
                <Icon key={i} id={i}
                  url={this.props.iconOrder[i]} 
                  onClick={(event) => this.handleClick(event, i)}
                  onMouseOver={() => this.onMouseOver(i)}
                  onMouseOut={() => this.onMouseOut()}
                />)}
            </div>
          </div>
      )
    }

    componentDidMount() {
      const coords = positionCircle(this.props.numIcons);
      const swappable = swappableIndices(this.props.numIcons);

      this.setState({
        coordinates: coords,
        swappable: swappable,
      });
    }
}

export default Board;